// extracted by mini-css-extract-plugin
export default {"orangeButton":"OrangeButton_orangeButton__ujCsY"};